import React, { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Box, Text, TextButton } from '@wix/design-system';
import { useBiLogger } from '../../providers/BiLoggerProvider';

export const FaqItem: React.FC<{
  faqIndex: number;
  linkCallbacks?: { [s: string]: Function } | Function;
  links: Record<string, string> | string;
}> = ({ faqIndex, links, linkCallbacks }) => {
  const { biLogger } = useBiLogger();
  const { t } = useTranslation();
  useEffect(() => {
    biLogger.faqItemExpandCollapse(t(`charge-locator.faqs.q${faqIndex + 1}`));
  }, []);

  return (
    <Box maxWidth="540px">
      <Text>
        <Trans i18nKey={`charge-locator.faqs.a${faqIndex + 1}`}>
          charge-
          <TextButton
            target="_blank"
            as="a"
            onClick={
              linkCallbacks
                ? typeof linkCallbacks === 'function'
                  ? () => linkCallbacks()
                  : () => linkCallbacks[1]()
                : () => {}
            }
            href={typeof links === 'object' ? links[1] : links}
          >
            locator.
          </TextButton>
          faqs.
          <TextButton
            target="_blank"
            as="a"
            onClick={
              linkCallbacks
                ? typeof linkCallbacks === 'function'
                  ? () => linkCallbacks()
                  : () => linkCallbacks[2]()
                : () => {}
            }
            href={links && links[2]}
          >
            __faq-number__.&nbsp;
          </TextButton>
          a
        </Trans>
      </Text>
    </Box>
  );
};
